var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamanteSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.656,
    height: 36.502,
    viewBox: "0 0 50.656 36.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu-icons",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-diamond"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4485",
    "data-name": "Path 4485",
    d: "M143.3,133c-2.627-7.323-5.255-14.665-7.9-22.1h16.026c-2.646,7.417-5.274,14.759-7.9,22.1Z",
    transform: "translate(-119.048 -98.498)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4486",
    "data-name": "Path 4486",
    d: "M215.739,110.53c-6.671,6.969-13.23,13.808-19.771,20.647-.056-.037-.112-.056-.168-.093.075-.261.13-.5.2-.764q3.41-9.532,6.839-19.082c.168-.447.261-.839.894-.839,3.783.037,7.584.019,11.367.019C215.254,110.437,215.385,110.475,215.739,110.53Z",
    transform: "translate(-167.139 -98.091)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4487",
    "data-name": "Path 4487",
    d: "M53.3,110.547h8.5c1.174,0,2.367-.037,3.541.019a1.138,1.138,0,0,1,.857.578q3.578,9.867,7.081,19.753a.469.469,0,0,1-.056.429C66.642,124.467,60.064,117.609,53.3,110.547Z",
    transform: "translate(-53.3 -98.201)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4488",
    "data-name": "Path 4488",
    d: "M135.6,58.945c.093-.317.149-.578.242-.839.857-2.422,1.752-4.826,2.572-7.267A1.063,1.063,0,0,1,139.625,50c2.627.037,5.274.037,7.9,0a1.016,1.016,0,0,1,1.137.8c.932,2.683,1.9,5.348,2.888,8.125C146.2,58.945,140.948,58.945,135.6,58.945Z",
    transform: "translate(-119.211 -50)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4489",
    "data-name": "Path 4489",
    d: "M69.872,50.336c-.354.988-.689,1.975-1.044,2.963-.615,1.714-1.211,3.447-1.863,5.143a1.231,1.231,0,0,1-.783.689c-3.876.037-7.752.019-11.628.019a1.421,1.421,0,0,1-.354-.13c1.4-1.472,2.758-2.907,4.118-4.323q1.9-2.04,3.857-4.025a1.417,1.417,0,0,1,.839-.466c2.18-.037,4.342-.019,6.522,0A1.386,1.386,0,0,1,69.872,50.336Z",
    transform: "translate(-54.032 -50.15)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4490",
    "data-name": "Path 4490",
    d: "M234.021,59.024c-.578.037-.876.056-1.174.056-3.5,0-7.025-.019-10.528.019a1.132,1.132,0,0,1-1.3-.95c-.8-2.367-1.677-4.733-2.516-7.1-.093-.261-.168-.522-.3-.969h1.919c1.547,0,3.112-.019,4.659.019a1.422,1.422,0,0,1,.932.28C228.43,53.192,231.132,56.005,234.021,59.024Z",
    transform: "translate(-185.365 -50.061)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamanteSelect);
export default __webpack_public_path__ + "static/media/diamante_select.01f92636d1b1279d78e6ab2eb129f576.svg";
export { ForwardRef as ReactComponent };